import m from "../../geodata/es2015/worldIndiaLow";
window.am4geodata_worldIndiaLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/worldIndiaLow.js
// module id = null
// module chunks = 